/**
 * Alarm Row Style.
 * @param {object} row
 * @returns {*}
 */
window.alarmRowStyle = function(row) {
    let classes = [];
    if (row.employee_status) {
        classes.push(row.employee_status);
    }
    if (row.customer_contact_status) {
        classes.push(row.customer_contact_status);
    }
    if (row.priority) {
        classes.push(row.priority);
    }
    if (row.priority_blinking) {
        classes.push(row.priority_blinking);
    }
    if (classes.length === 0) {
        return {};
    }
    classes = classes.join(' ');
    return {
        classes: classes
    };
};
